export default __webpack_public_path__ + "images/YN.63cc68c.png";